module.exports = __webpack_public_path__ + "422fab941e9f328d66acc94301594982.png";